import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'projectNaming'
})
export class ProjectNamingPipe implements PipeTransform {

    transform(value: string, ...args: unknown[]): string {
        switch (value) {
            case 'created':
                return 'Idee';
            case 'declined':
                return 'Idee';
            case 'line':
                return 'Quick Win';
            case 'in_elaboration':
                return 'Projektauftrag';
            case 'evaluation':
                return 'Projektauftrag';
            case 'cancelled':
                return 'Projektauftrag';
            case 'revise':
                return 'Projektauftrag';
            case 'released':
                return 'Projekt';
            case 'in_progress':
                return 'Projekt';
            case 'completion_filed':
                return 'Projekt';
            case 'completed':
                return 'Projekt';
            default:
                return '';
        }
    }

}
